"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatekeeperApiService = void 0;
var axios_1 = __importDefault(require("axios"));
var ExtractQueryParam_1 = __importDefault(require("./ExtractQueryParam"));
var Gatekeeper_1 = require("./Gatekeeper");
var GatekeeperApiService = (function () {
    function GatekeeperApiService(publicApiBaseUrl, location, Axios) {
        var _this = this;
        this.publicApiBaseUrl = publicApiBaseUrl;
        this.location = location;
        this.Axios = Axios;
        this.login = function (requestBody) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.post("".concat(this.publicApiBaseUrl, "/login"), requestBody)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.signup = function (requestBody) { return __awaiter(_this, void 0, void 0, function () {
            var reqBody;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reqBody = this.getSignupBody(requestBody);
                        return [4, this.post("".concat(this.publicApiBaseUrl, "/signup/signup"), reqBody)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.resetPassword = function (requestBody) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.post("".concat(this.publicApiBaseUrl, "/reset-password/email"), requestBody)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.setNewPassword = function (newPassword) { return __awaiter(_this, void 0, Promise, function () {
            var token, email;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = (0, ExtractQueryParam_1.default)(this.location, "sct");
                        email = (0, ExtractQueryParam_1.default)(this.location, "e");
                        if (!token || !email) {
                            throw new Error("Something went wrong. Please check the link in your Reset Password email or try resetting again.");
                        }
                        return [4, this.post("".concat(this.publicApiBaseUrl, "/reset-password/new"), {
                                token: token,
                                email: email,
                                newPassword: newPassword,
                            })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        this.post = function (url, body) { return __awaiter(_this, void 0, Promise, function () {
            var response, error_1, errorMessage;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _h.trys.push([0, 2, , 3]);
                        return [4, this.Axios.post(url, body, { withCredentials: true })];
                    case 1:
                        response = _h.sent();
                        if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.redirect) {
                            this.location.href = response.data.redirect;
                        }
                        else {
                            return [2];
                        }
                        return [3, 3];
                    case 2:
                        error_1 = _h.sent();
                        if (((_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.status) === 429) {
                            throw new Error("Rate Limit Exceeded");
                        }
                        errorMessage = ((_e = (_d = (_c = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e.message) || ((_g = (_f = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.message) || error_1.message;
                        throw new Error(errorMessage);
                    case 3: return [2];
                }
            });
        }); };
        this.withTemplate = (0, ExtractQueryParam_1.default)(this.location, Gatekeeper_1.GatekeeperSignupParamKeys.WithTemplate);
        this.withPage = (0, ExtractQueryParam_1.default)(this.location, Gatekeeper_1.GatekeeperSignupParamKeys.WithPage);
        this.fromPlan = (0, ExtractQueryParam_1.default)(this.location, "plan");
        this.signupEntryPoint =
            (0, ExtractQueryParam_1.default)(this.location, Gatekeeper_1.GatekeeperSignupParamKeys.EntryPoint) ||
                (0, ExtractQueryParam_1.default)(this.location, "entry");
    }
    GatekeeperApiService.prototype.getSignupBody = function (requestBody) {
        return __assign(__assign(__assign(__assign(__assign(__assign({}, requestBody), (this.signupEntryPoint ? { signupEntryPoint: this.signupEntryPoint } : {})), (this.signupEntryPointUrl ? { signupEntryPointUrl: this.signupEntryPointUrl } : {})), (this.fromPlan ? { fromPlan: this.fromPlan } : {})), (this.withTemplate ? { withTemplate: this.withTemplate } : {})), (this.withPage ? { withPage: this.withPage } : {}));
    };
    return GatekeeperApiService;
}());
exports.GatekeeperApiService = GatekeeperApiService;
var makeGatekeeperApiService = function (publicApiBaseUrl) {
    return new GatekeeperApiService(publicApiBaseUrl, window.location, axios_1.default);
};
exports.default = makeGatekeeperApiService;
